export const BASE_URL = "https://api.dreamerdesigns.com";
// export const BASE_URL = "https://devapi.dreamerdesigns.com";
// export const BASE_URL = "http://srv654577.hstgr.cloud:5001";
// export const BASE_URL = "http://localhost:3001";
export const API_URL =
  "Och8289v5Aty5S2oUG9PUKhSy2geZh9r3Wum(lhfAREdwEZ*%ZOeyAOa7XsWuOxGWs8KeWHgF*UwEwRjjZzIFaWTVs8R0s5m%9";

export const AUTH_BASE = "/auth";
export const SIGNUP = AUTH_BASE + "/signup";
export const LOGIN = AUTH_BASE + "/login";
export const LOGOUT = AUTH_BASE + "/logout";
export const UPDATE_FCM_TOKEN = AUTH_BASE + "/updateFcmToken";
export const SEND_OTP = AUTH_BASE + "/sendOtp";
export const VERIFY_OTP = AUTH_BASE + "/verifyOtp";
export const CHANGE_FORGOT_PASSWORD = AUTH_BASE + "/changeForgotPassword";
export const GET_PROJECTS_LIST = "/getProjectList";
export const GET_PROJECTS_DETAIL = "/getProjectDetail";
export const SEARCH_PROJECT = "/searchAndSortProjects";
export const START_TIMER = "/startTimer";
export const STOP_TIMER = "/endTimer";
export const GET_HOME_DATA = "/getHomeData";
export const GET_PROGRESS = "/getProgress";
export const GET_POINTS_DASHBOARD = "/getPointsDashboard";
export const GET_LEVEL_JOURNEY = "/getLevelJourney";
export const GET_STREAKS = "/getStreak";
export const ADD_PROJECT = "/addProject";
export const EDIT_PROFILE = AUTH_BASE + "/editProfile";
export const GET_PROFILE = AUTH_BASE + "/getProfile";
export const CHANGE_PASSWORD = AUTH_BASE + "/changePassword";
export const SCAN_PRODUCT = "/scanProduct";
export const DELETEACCOUNT = "/deleteAccount";
export const DELETEPROJECT = "/deleteProject";
export const EDITPROJECT = "/editProject";
export const EDITTIMER = "/editTimer";
export const UPDATEPROJECTSTATUS = "/updateProjectStatus";
export const GETSUBDETAIL = "/getSubscriptionDetail";
export const CANCELSUB = "/cancelSubscription";
export const VERIFYADD = "/verifyAddProject";
export const GETSUBSCRIPTIONPLAN = "/getSubscriptionPlans";
export const SEND_CANCEL_SUBS_OTP = "/sendCancelSubOtp";
export const VERIFY_CANCEL_SUBS_OTP = "/verfiyCancelSubOtp";
export const ADD_CANVAS_IMAGES = "/addCanvasImages";
export const GET_LEADERBOARD = "/getLeaderboardNew";
// export const GET_LEADERBOARD = "/getLeaderboardCurrent";
export const SEND_SUPPORT_EMAIL = "/sendSupportEmail";
export const GET_LEADERBOARD_DESCRIPTION = "/getLeaderboardDescription";
export const SYNC_USER_SHOPIFY = "/syncUserShopify";
export const GET_USER_ORDERS = "/getUsersOrders";
export const IMPORT_SHOPIFY_PRODUCTS = "/importShopifyProducts";
export const RESTART_PROJECT = "/restartProject";
export const GET_BADGES = "/getBadges";
export const GET_REWARDS = "/getRewards";
export const GET_REWARD_DETAILS = "/getRewardDetails";
export const REDEEMED_REWARD = "/claimReward";
export const PROJECT_AI_VERIFICATION = "/projectAIVerification";
export const CHECK_AI_VERIFICATION_LIMIT = "/checkAIVerificationLimit";
export const CLAIM_MILESTONE_POINTS = "/claimMilestonePoints";
export const REQUEST_REVIEW = "/requestReview";
